import React, { useState } from "react";
import {
  Alert,
  AlertTitle,
  Box,
  Button,
  Stack,
  Typography,
} from "@mui/material";
import Input from "../Base/Input";
import SubmitButton from "../common/SubmitButton";
import BasicRadio from "../Base/BasicRadio";
import { useNavigate, useLocation } from "react-router-dom";
import configData from "../../Config";
import Backdrop from "../common/Backdrop";
import LoadingDots from "../Lottie/LoadingDots";
import { apis } from "../../services/apiService";
import styles from "../../Style/Modules/udhyamReg.module.css";
import "../../Style/Theme/index.css";
import Note from "../common/Note";
import useSelector from "../../store/selector";
import {
  VerifyUdyam,
  constant,
  encryptData,
  loggerStore,
  multiDecryption,
} from "../../utils/utils";
import AlertPopup from "../common/AlertPopup";
import { encryptApiData } from "../../utils/apiEncryption";
export default function UdyogAadhaarForm() {
  const navigate = useNavigate();
  let location = useLocation();
  const [isUdyamRegError, setIsUdyamRegError] = useState("");
  const [inputdisabled, setInputDisabled] = useState(false);
  const [btnDisabled, setBtnDisabled] = useState(true);
  const [udyamInputvalue, setUdyamInputValue] = useState("");
  const [RValue, setRValue] = useState(false);
  const [loading, setLoading] = useState(false);
  const { setRecoilVal, getRecoilVal } = useSelector();
  const [finalErr, setFinalErr] = useState("");
  const handleChange = (e) => {
    setBtnDisabled(false);
    let ravalue = e.target.value;
    if (ravalue) {
      setIsUdyamRegError("");
      setUdyamInputValue("");
      setInputDisabled(true);
      setBtnDisabled(false);
      setRValue(true);
    } else setRValue(false);
  };
  const handleInputChange = (e) => {
    setUdyamInputValue(e?.target?.value);
    if (e.target.value && !VerifyUdyam(e?.target?.value)) {
      setIsUdyamRegError("Enter valid Udyam number");
      setBtnDisabled(true);
    } else {
      setIsUdyamRegError("");
      setBtnDisabled(false);
    }
  };
  const handleUdyamDetail = async (e) => {
    e.preventDefault();
    let getPreUdyamDatafromRecoil = getRecoilVal(
      constant.atomsName.UDYAM_DETAILS
    );
    if (getPreUdyamDatafromRecoil !== null) {
      let decrypteddata = await multiDecryption(getPreUdyamDatafromRecoil);
      let selectedKey = Object.keys(decrypteddata);
      if (selectedKey.includes(udyamInputvalue)) {
        let data = {
          AppId: location.state.AppId,
          anchor: location.state.anchor,
          program: location.state.program,
          source: location.state.source,
          udyamInputvalue,
        };
        navigate("/udhyam-registration/Udyam_Detail", {
          state: data,
        });
      } else {
        try {
          setLoading(true);
          const reqData = {
            aid: location.state.AppId,
            op: RValue,
            un: udyamInputvalue,
            show_details: true,
            karzaUdhyamDetailedResponse: null,
          };

          let resp = await apis.postApi(
            configData.API_URL + "Udhyam/UdhyamDetailed",
            {
              request: encryptApiData(reqData),
            }
          );
          let result = await resp.json();
          if (resp?.status === 200) {
            setLoading(false);
            // let objectResult = result.substring(2);
            let respDatawithObj = result?.data;
            respDatawithObj.result.aadharPhoto = location?.state?.userPhoto;
            respDatawithObj.result.userName = location?.state?.userName;
            setRecoilVal(constant.atomsName.UDYAM_DETAILS, {
              ...getPreUdyamDatafromRecoil,
              [udyamInputvalue]: await encryptData(
                JSON.stringify(respDatawithObj)
              ),
            });
            let data = {
              AppId: location.state.AppId,
              anchor: location.state.anchor,
              program: location.state.program,
              source: location.state.source,
              udyamInputvalue,
            };
            navigate("/udhyam-registration/Udyam_Detail", { state: data });
            loggerStore(
              location?.state?.AppId,
              `AddUdyam API response for success only for check details= ${JSON.stringify(
                result
              )}`,
              "Information"
            );
          }
        } catch (error) {
          const errorResult = JSON.parse(error?.message);
          setFinalErr(errorResult?.statusMessage);
          setLoading(false);
          loggerStore(
            location?.state?.AppId,
            `AddUdyam API response for failed only for check details= ${JSON.stringify(
              error
            )}`,
            "Information"
          );
        }
      }
    } else {
      try {
        setLoading(true);
        const reqData = {
          aid: location.state.AppId,
          op: RValue,
          un: udyamInputvalue,
          show_details: true,
          karzaUdhyamDetailedResponse: null,
        };

        let resp = await apis.postApi(
          configData.API_URL + "Udhyam/UdhyamDetailed",
          {
            request: encryptApiData(reqData),
          }
        );
        let result = await resp.json();
        if (resp?.status === 200) {
          setLoading(false);
          // let objectResult = result.substring(2);
          let respDatawithObj = result?.data;
          respDatawithObj.result.aadharPhoto = location?.state?.userPhoto;
          respDatawithObj.result.userName = location?.state?.userName;
          setRecoilVal(constant.atomsName.UDYAM_DETAILS, {
            [udyamInputvalue]: await encryptData(
              JSON.stringify(respDatawithObj)
            ),
          });
          let data = {
            AppId: location.state.AppId,
            anchor: location.state.anchor,
            program: location.state.program,
            source: location.state.source,
            udyamInputvalue,
          };
          navigate("/udhyam-registration/Udyam_Detail", { state: data });
          loggerStore(
            location?.state?.AppId,
            `AddUdyam API response for success only for check details= ${JSON.stringify(
              result
            )}`,
            "Information"
          );
        }
      } catch (error) {
        const errorResult = JSON.parse(error?.message);
        setFinalErr(errorResult?.statusMessage);
        setLoading(false);
        loggerStore(
          location?.state?.AppId,
          `AddUdyam API response for failed only for check details= ${JSON.stringify(
            error
          )}`,
          "Information"
        );
      }
    }
  };
  let handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const reqData = {
        aid: location.state.AppId,
        op: RValue,
        un: udyamInputvalue,
        show_details: false,
      };

      let resp = await apis.postApi(
        configData.API_URL + "Udhyam/UdhyamDetailed",
        {
          request: encryptApiData(reqData),
        }
      );
      let result = await resp.json();
      if (resp.status === 200) {
        setLoading(false);
        if (RValue) {
          let data = {
            AppId: location.state.AppId,
            anchor: location.state.anchor,
            program: location.state.program,
            source: location.state.source,
          };
          navigate("/OrgDetails", { state: data });
        } else {
          let data = {
            AppId: location.state.AppId,
            anchor: location.state.anchor,
            program: location.state.program,
            source: location.state.source,
          };
          navigate("/upload-udhyam", { state: data });
        }
        loggerStore(
          location?.state?.AppId,
          `AddUdyam API response for success on Final Submit= ${JSON.stringify(
            result
          )}`,
          "Information"
        );
      }
    } catch (error) {
      setLoading(false);
      const errorResult = JSON.parse(error?.message);
      console.log("errorResult  =", errorResult);

      setFinalErr(errorResult?.statusMessage);
      loggerStore(
        location?.state?.AppId,
        `AddUdyam API response for catch on Final Submit= ${JSON.stringify(
          error
        )}`,
        "Information"
      );
    }
  };

  const handleClosedFunk = () => {
    setFinalErr("");
  };

  return (
    <Box
      component="form"
      onSubmit={handleUdyamDetail}
      autoComplete="off"
      className={styles.udyamRegBox}
    >
      <Note
        note="Enter your 19 digit Udyam Registration Number (i.e. UDYAM-XX-00-0000000)."
        udyamNote="udyamNote"
      />
      <Input
        type="text"
        autoComplete="off"
        name="udhyamRegistration"
        label="Udyam Registration"
        disabled={inputdisabled}
        onChange={handleInputChange}
        value={udyamInputvalue}
      />
      {isUdyamRegError && (
        <Box mt={-3} ml={0}>
          <Typography variant="p" color="subtitle" className="errorMsg_Th">
            {isUdyamRegError}
          </Typography>
        </Box>
      )}
      {/* <Button
        className="subTitle_Th"
        variant="contained"
        onClick={handleUdyamDetail}
        disabled={isUdyamRegError || !udyamInputvalue}
      >
        Show Udyam Detail
      </Button> */}
      {/* <div className={styles.udhyamReg}>
        <BasicRadio
          label="I do not have Udhyam Registration number"
          value="true"
          name="do not have udhyam registration"
          onChange={handleChange}
        />
      </div> */}
      {loading && (
        <Backdrop ax="center">
          <LoadingDots />
        </Backdrop>
      )}
      {finalErr && (
        <Backdrop ax="center">
          <AlertPopup finalErr={finalErr} handleClosed={handleClosedFunk} />;
        </Backdrop>
      )}
      <SubmitButton
        hasNote="No"
        disabled={btnDisabled || (RValue ? udyamInputvalue : !udyamInputvalue)}
      />
    </Box>
  );
}
